<template>
    <div class="acomodar">
        <GestionSolicitud/>
    </div>
</template>

<script>
import GestionSolicitud from '@/components/ModSeleccion/Gestion/GesSolicitudPrincipal.vue';
import '@/assets/styles/global-acomodar.css'; // Importar el estilo global
export default {
    name: "SolimanologGestiononDeSolicitudes",
    data() {
        return {};
    },
    mounted() {
    },

    created(){
        this.cambiarEstadoNavbar()
    },
    methods: {
        
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch('acciones/CambioNavbar', true);
    }

    },
    components: { GestionSolicitud }
};
</script>

<style scoped>

</style>